import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'

const renderCheckbox = ({ checked, onClick }) => {
  return <Checkbox checked={checked} onChange={onClick} />
}

export default renderCheckbox
